export default __webpack_public_path__ + "static/media/ticket@2x.cd82eee2.png";